export default "__VITE_ASSET__Cor9Qpug__"